import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "ad563c50-1e84-4f17-8671-e9edc6a13f5a",
    label: "DG(BLDG)'s Office Order No. 06 of 2020-2021",
    date: "25/02/2020",
    subject: "Procedure to issue notice for Section 411 on Dangerous building",
  },
  {
    fileStoreId: "4d93cbb1-241c-431a-8aa8-d585dff4348c",
    label: "DG(BLDG)'s Office Order No. 05 of 2020-2021",
    date: "24/02/2020",
    subject: "Non discloser of complainant name",
  },
  {
    fileStoreId: "c25c45d2-19ce-46dc-bbc0-8031af80dda8",
    label: "DG(BLDG)'s Office Order No. 04 of 2020-2021",
    date: "24/02/2020",
    subject: "Non refusals of Summons of any court",
  },
  {
    fileStoreId: "d846c1bf-642c-4be5-82fa-dd6275dd64dc",
    label: "DG(BLDG)'s Office Order No. 03 of 2020-2021",
    date: "04/02/2020",
    subject: "Monthly Report on case pending in MM court but regularized",
  },
  {
    fileStoreId: "f657bc21-acab-4fed-ac8b-74d4230f5aae",
    label: "DG(BLDG)'s Office Order No. 02 of 2020-2021",
    date: "03/11/2020",
    subject: "List of premises rejected by Competent Authority, land ceiling",
  },
  {
    fileStoreId: "9c077f57-b90a-4f79-8397-eb8d68cbe504",
    label: "DG(BLDG)'s Office Order No. 01 of 2020-2021",
    date: "16/09/2020",
    subject: "How to manage a file",
  },
];

const Building_OfficeOreder_2020 = () => (
  <TableStructure
    title="Office Order/ 2020"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2020;
